export default "__VITE_ASSET__98f91c50__"